import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { InvestorCompanyResponse, EventInfoWithConsentResponse, CountryResponse, CountryPublicControllerService, APIResult } from '@ent-regis/entregis-ts-angular';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-investor-profile',
  templateUrl: './investor-profile.component.html',
  styleUrls: ['./investor-profile.component.scss']
})
export class InvestorProfileComponent implements OnInit, OnChanges {

  @Input() profileForm: FormGroup;
  @Input() companies: InvestorCompanyResponse[];
  @Input() eventInfoWithConsent: EventInfoWithConsentResponse;
  @Input() isClosedRegis: boolean = false;
  @Output() onSuccessEvent = new EventEmitter<any>();

  countries: CountryResponse[] = [];
  savedEmail: string = '';

  constructor(
    private countryPublicService: CountryPublicControllerService,
  ) { }

  get shouldShowPreferenceSection(): boolean {
    return !!this.eventInfoWithConsent && this.eventInfoWithConsent.isShowSalePersonForInvestorRegistration;
  }

  ngOnInit() {
    this.getCountries();
    this.savedEmail = (this.profileForm && this.profileForm.get('email') && this.profileForm.get('email').value) || '';
    this.updateFormState();
  }

  ngOnChanges() {
    this.updateFormState();
  }


  private getCountries(): void {
    this.countryPublicService.getCountryUsingGET().subscribe((result: APIResult) => {
        this.countries = result.data;
      }
    );
  }

  onSubmit(): void {
    if (this.isClosedRegis) {
      return;
    }
    if (this.profileForm.invalid) {
      this.profileForm.markAllAsTouched();
      return;
    }
    this.savedEmail = (this.profileForm && this.profileForm.get('email') && this.profileForm.get('email').value) || '';
    this.onSuccessEvent.emit(this.profileForm.value);
  }

  private updateFormState(): void {
    if (!this.profileForm) {
      return;
    }

    if (this.isClosedRegis) {
      this.profileForm.disable({ emitEvent: false });
      return;
    }

    this.profileForm.enable({ emitEvent: false });
  }

}
